import { render, staticRenderFns } from "./purchaseProductInfo.vue?vue&type=template&id=57b6d900"
import script from "./purchaseProductInfo.vue?vue&type=script&lang=js"
export * from "./purchaseProductInfo.vue?vue&type=script&lang=js"
import style0 from "./purchaseProductInfo.vue?vue&type=style&index=0&id=57b6d900&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports